export const LANGUAGES = ['lv', 'en']
